import api from "api/api";

export const createMissionManagerQuery = async (data) =>
  await api.post(`/mission-manager`, data);

export const getMissionManagerByIdQuery = async (id) =>
  await api.get(`/mission-manager/${id}`);

export const getMissionManagerByMissionIdQuery = async ({ id, userScope }) =>
  await api.get(`/mission-manager/mission/${id}?scope=${userScope}`);

export const editMissionManagerQuery = async ({ id, data ,userScope}) =>
  await api.put(`/mission-manager/${id}?scope=${userScope}`, data);

export const deleteMissionManagerQuery = async (id) =>
  await api.delete(`/mission-manager/${id}`);

export const getMissionHistoryManagerByMissionIdQuery = async (id) =>
  await api.get(`/mission-manager/mission/${id}`);
